/**
 * Turns the constructor's selectedItemList into the chargeDataList the ToH backend expects.
 * Shared by the single-user charger and the mass-charge wizard.
 */
export function buildChargeDataListToh(selectedItemList) {
    try {
        let dataList = []

        selectedItemList.forEach(item => {
            // Пропускаем items без выбранного типа
            if (!item.item || !item.item.value) return;

            // guid только если реально выбран (не пустой emptyOption)
            const hasGuid = item.item.guidMap !== "" && item.guid?.guid;
            const hasGuid2 = item.item.guidMap2 !== "" && item.guid2?.guid;

            let keys = [];
            if (hasGuid) keys.push(item.guid.guid);
            if (hasGuid2) keys.push(item.guid2.guid);

            let data = {keys};

            let amountAttribute = item.item.amountAttribute != undefined && item.item.amountAttribute !== ''
                ? item.item.amountAttribute
                : 'count';

            if (item.item.amount !== false)
                data[amountAttribute] = item.amount === undefined ? 0 : item.amount;

            if (item.mephistoTag !== undefined && item.mephistoTag !== "") {
                data["mephistoTag"] = item.mephistoTag;
            }
            if (item.duration !== undefined && item.duration !== "") {
                data["duration"] = parseInt(item.duration);
            }
            if (item.stringArgs !== undefined && item.stringArgs !== "") {
                data["stringArgs"] = item.stringArgs;
            }
            if (item.supportId !== undefined && item.supportId !== "") {
                data["supportId"] = item.supportId;
            }

            // key (guid) — пишем только если guid выбран
            if (item.item.hasOwnProperty('key') && hasGuid) {
                data[item.item.key] = item.guid.guid;
            }

            // key2 (guid2) — пишем только если guid2 выбран
            if (item.item.guidMap2 !== "" && hasGuid2) {
                data[item.item.key2] = item.guid2.guid;
            }

            if (item.endTime && item.item.endTime === true) {
                const endTime = typeof item.endTime === "string" ? item.endTime : item.endTime.format('YYYY-MM-DDTHH:mm:ss[Z]');
                data['endTime'] = endTime;
            }

            if (
                item.hasOwnProperty('guid') && item.guid != '' &&
                item.guid?.hasOwnProperty('label') &&
                item.guid?.hasOwnProperty('x') &&
                item.guid?.hasOwnProperty('y')
            ) {
                if (item.guid.label != null) {
                    data["label"] = item.guid.label;
                    data["mockSize"] = {x: parseInt(item.guid.x), y: parseInt(item.guid.y)};
                }
            }

            dataList.push({
                "type": item.item.value,
                "data": data,
                "displayName": item.guid ? item.guid.displayName : (item.guid2 ? item.guid2.displayName : item.item.name)
            })
        })

        return dataList
    } catch (e) {
        return []
    }
}
